import clearfix from '../../styles/tools/clearfix'

export default () => ({
  clearfix: {
    ...clearfix()
  }
})



// WEBPACK FOOTER //
// ./components/clearfix/styles.js